import axios from "axios";
import { baseUrl } from "../../config/url-config";
import { getDataLogin } from "../../utils/getDataLogin";

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

// Setiap sebelum request cek dan kirim token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getDataLogin()?.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Jika error 401 (token expire/invalid) maka logout
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("data-login");
      window.location.href = "/#/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
